import React, { Component } from 'react';
import ButtonPanel from '../../QbmPage/ButtonPanel';
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { getRooms, setRoomItem, getQuizs } from '../actions';
import classNames from 'classnames';
import moment from 'moment';
import {sortBy} from 'lodash';


class Rooms extends Component {
  static contextTypes = {formatMessage: PropTypes.any};

  componentDidMount(){
    this.props.getRooms();
  }

  render() {
    const {formatMessage} = this.context;
    const { rooms, room } = this.props;
    
    return (
      
        <div className="qbm-accordion-component rooms">
          <div className="qbm-accordion-title">
            {formatMessage('titleClassRoomSidebar')}
          </div>
          <div className="posr qbm-accordion-body open">
            <div className="qbm-accordion-content">
              {sortBy(rooms, ['x_order']).map(item => (
                <div
                  key={`room-item-${item.id}`}
                  className={classNames("qbm-accordion-content__item ", {'qbm-accordion-content__item--selected': room && room.id == item.id ? true : false})}
                  onClick={() => {
                    this.props.setRoomItem(item);
                    this.props.getQuizs(item.id);
                  }}
                >
                  <span className="text-ellipsis">{item.title}</span> <span className={item.status && moment() >= moment(item.active_from * 1000) && moment() <= moment(item.active_to * 1000)  ? 'marker-published' : 'marker-unpublished'} />
                </div>
              ))}
            </div>
          </div>
      </div>
    );
  }
}


const mapStateToProps = (state, ownProps) => ({
  rooms: state.statistic_report.rooms,
  room: state.statistic_report.room,
})

const mapDispatchToProps = {
  setRoomItem,
  getQuizs,
  getRooms,
}

export default connect(mapStateToProps, mapDispatchToProps)(Rooms)


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/StatisticReports/Rooms/index.jsx